export default "__VITE_ASSET__DUY$jyjt__"